import React from 'react';
import PageContent from '../../../components/Page/components/PageContent';

export default function NotFoundContent() {
  return (
    <PageContent title="Pagina non trovata">
      <h3>La risorsa richiesta non è stata trovata</h3>
    </PageContent>
  );
}
